'use client'

import { ToasterToast, useToast } from '@/hook/use-toast'
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/toast'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

export function Toaster({ toasts }: { toasts: ToasterToast[] }) {
  return (
    <ToastProvider>
      {toasts?.map(function ({
        id,
        title,
        description,
        image,
        action,
        ...props
      }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex items-center gap-4">
              <Avatar className=" text-[#6eac36] text-muted-foreground outline-none">
                <AvatarImage src={image || '/placeholder.svg'} />
                <AvatarFallback>JD</AvatarFallback>
              </Avatar>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
